<glxy-form-field suffixText=".00">
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.FILTERS.ORDER_DATA.DATA_LABELS.AMOUNT' | translate }}
  </glxy-label>
  <input matInput type="number" class="right-align" placeholder="0" [formControl]="inputControl" />
  <glxy-error *ngIf="inputControl.invalid && inputControl.dirty">
    {{ 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.ERRORS.NUMBER_NOT_POSITIVE' | translate }}
  </glxy-error>
</glxy-form-field>
